import React, { useEffect } from "react";
import { StringParam, useQueryParam, withDefault } from "use-query-params";
import { useAppInitializer } from "@hooks/useAppInitializer";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { getUserProfile, handleLogin } from "@lib/auth0";
import { handleGoogleAuth } from "@lib/user";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import { useToaster } from "@design-system/ToastMessages/useToaster";

export const GoogleAuth: React.FC = () => {
    const [inviteCode] = useQueryParam(
        "inviteCode",
        withDefault(StringParam, undefined),
    );
    const navigate = useStateAwareNavigate();
    const { error } = useToaster();
    const { initialize } = useAppInitializer();

    useEffect(() => {
        handleLogin()
            .then((token) => getUserProfile(token))
            .then((user) =>
                handleGoogleAuth({
                    auth0UserId: user.sub,
                    name: user.name,
                    avatar: user.picture,
                    email: user.email!,
                    inviteCode,
                }),
            )
            .then(() => initialize())
            .catch((e) => {
                error(e.errorDescription ?? e.message ?? "Unknown error");

                navigate("/");
            });
    }, [error, inviteCode, navigate, initialize]);

    return <PageCoverLoader />;
};
